<template>
    <v-main>
        <v-row class="ma-0">
            <v-col sm="6" class="d-flex align-end justify-end pb-5 pr-5">
                <strong class="white--text">&copy; {{ new Date().getFullYear() }} TCO TEAM.</strong>
            </v-col>
            <v-col sm="6" class="d-flex justify-center align-center">
                <section class="d-flex flex-column align-center">
                    <router-link :to="{name : 'Home'}">
                        <img :src="require('@/../public/images/TcoTeam.png')">
                    </router-link>

                    <h1>{{$t("auth.restore")}}</h1>

                    <p class="mb-11">{{$t("auth.description")}}</p>

                    <section class="sectionForm">
                        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                            <v-form @submit.prevent="handleSubmit(send)">
                                <ValidationProvider vid="email" :name="$t('auth.email')" rules="required|email" v-slot="{ errors }">
                                    <v-text-field :label="$t('auth.email')"
                                                  type="email"
                                                  v-model="restore.email"
                                    >
                                        <template v-slot:prepend-inner>
                                            <svg v-svg="'icon-email'" size="15" class="mr-1"></svg>
                                        </template>
                                    </v-text-field>
                                    <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                                </ValidationProvider>


                                <v-card-actions class="justify-center mt-7" v-if="!firstSend">
                                    <v-btn class="white--text" color="green" type="submit" :loading="loadingRequest" width="90" height="30">{{$t("auth.send")}}</v-btn>
                                </v-card-actions>

                            </v-form>
                        </ValidationObserver>
                    </section>

                    <div v-if="firstSend" class="mt-10">
                        <p class="ma-0">{{$t("auth.get_an_email")}} <span @click="send" class="again">{{$t("auth.again")}}</span></p>
                        <p v-show="timerCount" class="timer mt-1 mb-0">{{timerCount}}</p>
                    </div>

                    <p class="mt-7">{{$t("auth.notRegistered")}}
                        <router-link :to="{name : 'Register'}" class="green--text">
                            {{$t("auth.createAccount")}}
                        </router-link>
                    </p>
                </section>

                <v-footer fixed class="d-none transparent mb-3">
                    <strong class="mx-auto">&copy; {{ new Date().getFullYear() }} TCO TEAM.</strong>
                </v-footer>
            </v-col>
        </v-row>
    </v-main>
</template>

<script>
    export default {
        data(){
            return {
                restore: {},
                loadingRequest: false,
                firstSend: false,
                timerCount: null,
            }
        },

        watch: {
          timerCount: {
              handler(value){
                  if (value > 0) {
                      setTimeout(() => {
                          this.timerCount--;
                      }, 1000);
                  }
              },
              immediate: true,
          },
        },

        methods: {
            send(){
                if(!this.timerCount){
                    this.loadingRequest = true;
                    this.$api('auth').restore(this.restore)
                        .then((res) => {
                            this.firstSend = true;
                            this.timerCount = 30;
                            this.$store.dispatch('alert', {type: 1, message: res.data.message})
                        }).catch((err) => {
                        if (err.response.status === 422) this.$refs.form.setErrors(err.response.data);
                        if (err.response.status === 302 ) this.$store.dispatch('alert', {type: 4, message: err.response.data.message});
                    }).finally(() => {
                        this.loadingRequest = false;
                    })
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../scss/pages/auth";
</style>